import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";

export default function ProfileModelLanguage({
  edittype,
  formData,
  setFormData,
  setModalLanguage,
}) {
  const [validation, setValidation] = useState(false);
  const [allLanguage, setAllLanguage] = useState("");
  const [optionsss, setOptionsss] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedLanguages, setSelectedLanguages] = useState(
    formData.language || [],
  );
  const languagelist = useSelector(
    ({ categary: { languagelist } }) => languagelist,
  );
  const proficiencylist = useSelector(
    ({ categary: { proficiencylist } }) => proficiencylist,
  );

  useEffect(() => {
    setAllLanguage(languagelist);
  }, [languagelist]);

  const dispatch = useDispatch();
  useEffect(() => {
    setOptionsss(proficiencylist);
  }, [proficiencylist]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      language_id: selectedOption.value,
      proficiency_id: "",
      language_title: selectedOption.label,
      proficiency_title: "",
    };
    setSelectedLanguages([...selectedLanguages, newLanguage]);
    setSelectedLanguage(null);
    setValidation(false);
  };

  const handleProficiencyChange = (selectedOption, index) => {
    const updatedLanguages = [...selectedLanguages];
    updatedLanguages[index].proficiency_id = selectedOption.value;
    updatedLanguages[index].proficiency_title = selectedOption.label;
    setSelectedLanguages(updatedLanguages);
  };

  const handleDeleteLanguage = (languageId) => {
    const updatedLanguages = selectedLanguages.filter(
      (language) => language.language_id !== languageId,
    );
    setSelectedLanguages(updatedLanguages);
  };

  const validateLanguages = () => {
    return selectedLanguages.every((language) => language.proficiency_id);
  };

  const handleSave = () => {
    if (validateLanguages() && selectedLanguages?.length > 0) {
      const data = {
        type: "language",
        language: selectedLanguages,
      };
      if (edittype === 1) {
        dispatch(updateProfile(data));
        setModalLanguage(false);
      } else {
        setFormData((prevData) => ({
          ...prevData,
          language: selectedLanguages,
        }));
        setModalLanguage(false);
      }
    } else {
      setValidation(true);
    }
  };

  return (
    <>
      <button
        onClick={() => setModalLanguage((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <div>
          <div>
            <div className="skill">
              <h6>Add your language</h6>
              <div className="skill-img">
                <button className="btn skill-img-btn">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/select-icon.svg`}
                    alt=""
                  />
                </button>
                <ReactSelect
                  options={
                    Array.isArray(allLanguage) &&
                    allLanguage
                      .filter(
                        (lang) =>
                          !selectedLanguages.some(
                            (selectedLang) =>
                              selectedLang.language_id === lang.id,
                          ),
                      )
                      .map((lang) => ({ value: lang.id, label: lang.title }))
                  }
                  placeholder="Select language"
                  isClearable={true}
                  value={selectedLanguage}
                  onChange={handleLanguageChange}
                />
              </div>
            </div>

            <div>
              {Array.isArray(selectedLanguages) &&
                selectedLanguages.map((language, index) => (
                  <div key={index} className="language row">
                    <div className="form-group col-md-5">
                      <label>{`${index + 1}. Language: `}</label>
                      <input
                        value={
                          Array.isArray(allLanguage) &&
                          allLanguage.find(
                            (lang) => lang.id === language.language_id,
                          )?.title
                        }
                        disabled
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label">Proficiency</label>
                      <ReactSelect
                        options={
                          Array.isArray(optionsss) &&
                          optionsss.map((val) => ({
                            value: val.id,
                            label: val.title,
                          }))
                        }
                        placeholder="Select Proficiency"
                        value={
                          Array.isArray(optionsss) &&
                          optionsss.find(
                            (val) => val.id === language.proficiency_id,
                          )
                            ? {
                                value: language.proficiency_id,
                                label: optionsss.find(
                                  (val) => val.id === language.proficiency_id,
                                ).title,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleProficiencyChange(selectedOption, index)
                        }
                      />
                    </div>

                    <div className="delete-btn-language"
                      onClick={() => {
                        handleDeleteLanguage(language.language_id);
                      }}
                    >
                      <label className="d-block">&nbsp;</label>
                      <button>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
            {validation && (
              <p style={{ color: "red" }}>
                At least add one language with proficiency
              </p>
            )}
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
